export default __webpack_public_path__ + "images/monochrome.564b739.svg";